import React from "react";
import PropTypes from "prop-types";
import {
  TableRow,
  TableCell,
  IconButton,
  Checkbox,
  makeStyles,
  Collapse,
  Box,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import DayRecords from "./DayRecords";
import { useTranslation } from "react-i18next";
import { PENDING_I18N } from "config/CONSTANTS";

const useStyles = makeStyles(() => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  punchDetailsTable: {
    border: "1px solid #e0e0e0",
  },
}));

const DayItem = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { row, isItemSelected, handleClick, labelId } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow className={classes.root} onClick={() => setOpen(!open)}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            // onClick={() => setOpen(!open)}   // expand on full row click
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell padding="checkbox">
          {!row.isApproved &&
            row.durationInHrs > 0 &&
            // t(row.status) === PENDING && (
            row.status === PENDING_I18N && (
              <Checkbox
                checked={isItemSelected}
                inputProps={{ "aria-labelledby": labelId }}
                onClick={(event) => handleClick(event, row)}
              />
            )}
        </TableCell>

        <TableCell component="th" scope="row">
          {row.durationInHrs}
        </TableCell>
        <TableCell>{row.day}</TableCell>
        <TableCell align="right">{t(row.status)}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              {
                // Nested table to display the datagrid with all punch records for current expanded day.
              }
              {row.punches.length > 0 ? (
                <DayRecords row={row} worker={props.worker}
                deleteHandler={props.deleteHandler} />
              ) : (
                <Typography variant="h6" gutterBottom component="div">
                  {t("pgReview.tableStaticText.noRecords")}
                </Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

DayItem.propTypes = {
  worker: PropTypes.object,
  handleClick: PropTypes.func.isRequired,
  isItemSelected: PropTypes.bool.isRequired,
  labelId: PropTypes.string,
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    //durationInMins: PropTypes.number.isRequired,
    durationInHrs: PropTypes.number.isRequired,
    hours: PropTypes.string.isRequired,
    day: PropTypes.string.isRequired,
    isApproved: PropTypes.bool,
    status: PropTypes.string,
    editable:PropTypes.bool,
    punches: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        jobName: PropTypes.string.isRequired,
        activityName: PropTypes.string.isRequired,
        activityTS: PropTypes.string,
        inLocalTS: PropTypes.string,
        activityGroup: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default DayItem;
